import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 创建串货商关系
export function relationCreate (params: {
  distributorId: string;
  distributorPwd: string;
  supplierId: string;
  syncCustId: string;
  syncdbLink: string;
}): any {
  return request(`/saas/gtpw/relation/create?${formatParam(params)}`)
}

// 一键快速创建串货商关系
export function fastCreate (params: {
  syncParentCustId: string;
  syncdbLink: string;
}): any {
  return request(`/saas/gtpw/relation/fastCreate?${formatParam(params)}`)
}

// 引用产品
export function quotes (data: {
  dbLink: string;
  infoId: string;
  parentMchId: string;
}): any {
  return request('/saas/gtpw/relation/quotes', {
    method: 'POST',
    data
  })
}

// 解绑产品 -- 取消引用
export function unbind (data: {
  dbLink: string;
  infoId: string;
  newInfoId: string;
  parentMchId: string;
}): any {
  return request(`/saas/gtpw/relation/unbind?${formatParam(data)}`, {
    method: 'DELETE'
  })
}

// 快速定位供应商
export function relationUsrs (params: {
  areaId: string | number;
  custName: string;
}): any {
  return request(`/saas/gtpw/relation/usrs?${formatParam(params)}`)
}

// 解除串货关系
export function dissolutionRelation (data: {
  dbLink: string;
  parentMchId: string;
  type: string | number
}): any {
  return request(`/saas/gtpw/relation/dissolutionRelation?${formatParam(data)}`, {
    method: 'POST'
  })
}
